import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "hstack gap-2 align-self-end" }
const _hoisted_2 = {
  key: 0,
  class: "b-table-header-info"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

import { computed, ref, watch, onMounted } from 'vue';
import { BTableOptions, BSelectOptionsNumber } from "@/components/BTable/BTable.types";
import { BFilter } from '../BFilterEditor/BFilterEditor.types';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaginationNoLastOrTotal',
  props: {
    value: {},
    headerSlotClass: { default: '' },
    filters: { default: [] },
    isNextDisabled: { type: Boolean, default: false },
    currentItemCount: {}
  },
  emits: ['optionChange'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;
    
    var options = ref(props.value as BTableOptions);

    const itemsPerPageOptions = [
        { text: "25", value: 25 },
        { text: "50", value: 50 },
        { text: "100", value: 100 }
        ] as BSelectOptionsNumber[];    


    var isPreviousDisabled = computed(():boolean => {
        return options.value.page == 1;
    });

    var isNextDisabled = computed(():boolean => {
        return props.isNextDisabled || props.currentItemCount <= options.value.itemsPerPage;
    });

    var totalLabelValue = ref('');
    
    function setTotalLabel() {
        /*
        CI-2598 - Current Requirements
        If the filters contain one of the following then show the total item count otherwise hide it. 
            - All outstanding errors and warnings
            - All outstanding errors
            - All outstanding warnings
            - All outstanding errors and warnings for a single ORI
            - All outstanding errors for a single ORI
            - All outstanding warnings for a single ORI
        */
       
        let start = props.currentItemCount == 0 ? 0 : (options.value.page - 1) * options.value.itemsPerPage + 1;

        let itemCount = props.currentItemCount;
        
        //adjusting itemCount to account for the +1 item we include to determine if the next button should be enabled
        if(props.currentItemCount == options.value.itemsPerPage + 1){
            itemCount = itemCount - 1;
        }

        let end = start + itemCount - 1;
        
        if(end < 0){
            end = 0;
        }

        let label = `${start} - ${end}`;

        let hasOutstandingFilter = false;

        props.filters.forEach((filter:BFilter)=> {
            if(filter.property === 'status' && filter.value === 'Unresolved'){
                hasOutstandingFilter = true;
            }

            //insert other checks here
        });
        //if conditions are met then set the item total
        if(hasOutstandingFilter) {
            label += ` of ${options.value.totalItemCount}`;
        }
        else if(props.currentItemCount <= options.value.itemsPerPage) {
            label += ` of ${end}`
        }
        else {
            label += ` of many`;
        }
        
        totalLabelValue.value = label;
    };

    function goToPage(pageNumber: number) {       
        options.value.page = pageNumber;
        emits("optionChange", options.value);
    }
    
    function go(deltaPage: number) {
        goToPage(Math.max(1, options.value.page + deltaPage));
    }
            
    function setItemsPerPage(e:any) { 
        options.value.itemsPerPage = options.value.itemsPerPage;
        options.value.page = 1;
        emits("optionChange", options.value);
    }

    function first() {
        goToPage(1);
    }
    
    watch(
        () => props.value,
        (newOptions) => {
            setTotalLabel();
        },
        {
            deep:true
        }
    );
    
    watch(
        () => props.currentItemCount,
        () => {
            setTotalLabel();
        }
    );

    onMounted(() => {
        setTotalLabel();    
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(totalLabelValue) != '')
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_unref(totalLabelValue)), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("select", {
      class: "form-select b-table-header-pagesize py-1 border border-dark",
      "aria-label": "Select Page Size",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.itemsPerPage) = $event)),
      onChange: setItemsPerPage,
      placeholder: "Select an agency"
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(itemsPerPageOptions, (option) => {
        return _createElementVNode("option", {
          value: option.value
        }, _toDisplayString(option.text), 9, _hoisted_3)
      }), 64))
    ], 544), [
      [
        _vModelSelect,
        _ctx.value.itemsPerPage,
        void 0,
        { number: true }
      ]
    ]),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass('btn btn-sm ' + (!_unref(isPreviousDisabled)?'border border-dark':'')),
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (first()), ["prevent"])),
      disabled: _unref(isPreviousDisabled),
      "data-bs-toggle": "tooltip",
      "data-bs-title": "First Page"
    }, _cache[4] || (_cache[4] = [
      _createElementVNode("i", { class: "bi bi-chevron-double-left" }, null, -1)
    ]), 10, _hoisted_4),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass('btn btn-sm ' + (!_unref(isPreviousDisabled)?'border border-dark':'')),
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (go(-1)), ["prevent"])),
      disabled: _unref(isPreviousDisabled),
      "data-bs-toggle": "tooltip",
      "data-bs-title": "Previous Page"
    }, _cache[5] || (_cache[5] = [
      _createElementVNode("i", { class: "bi bi-chevron-left" }, null, -1)
    ]), 10, _hoisted_5),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass('btn btn-sm ' + (!_unref(isNextDisabled)?'border border-dark':'')),
      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (go(+1)), ["prevent"])),
      disabled: _unref(isNextDisabled),
      "data-bs-toggle": "tooltip",
      "data-bs-title": "Next Page"
    }, _cache[6] || (_cache[6] = [
      _createElementVNode("i", { class: "bi bi-chevron-right" }, null, -1)
    ]), 10, _hoisted_6)
  ]))
}
}

})